//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {NsModal} from '@nuskin/design-components';
import pagedown from 'pagedown';

export default {
  name: 'SubscriptionsModal',
  components: {NsModal},
  props: {
    triggerText: {
      type: String,
      default: () => ''
    },
    modalData: {
      type: Object,
      default: () => ({
        content: [],
        footer: ''
      })
    }
  },
  data() {
    return {
      showModal: false
    };
  },
  methods: {
    convertMarkdown(paragraph) {
      if (!paragraph) return '';
      const safeConverter = pagedown.getSanitizingConverter();
      return safeConverter
        .makeHtml(paragraph)
        .replace(/<a /g, `<a target="_blank" `);
    },
    onclose() {
      this.setShow(false);
    },
    setShow(state) {
      this.showModal = state;
    }
  }
};
